  import axios from 'axios';

import RedisInfo from './RedisInfo';
const apiUrl = process.env.REACT_APP_API_URL;
 

const trxReportDetails = async (serviceName,selectedPlan,lang) => {
    try {
        const responseRedisData = await RedisInfo.redisDetails();
       
      const parentGroup = responseRedisData.ParentGroup
      console.log("parentGroup in trxReportDetails:", parentGroup);
      const dealerMapCode=responseRedisData.DealerMapCode
      console.log("dealerMapCode in trxReportDetails:", dealerMapCode);
      const locCode=responseRedisData.LocCode
      console.log("locCode in trxReportDetails:", locCode);
      
      
       
      const token =sessionStorage.getItem('token');
      
   
    
      const baseURL = `${apiUrl}/api/v1/orderDetails/getTransactionsReport/${parentGroup}/${dealerMapCode}/${locCode}`;
      const params = new URLSearchParams();
      
      if (serviceName) params.append("serviceId", serviceName);
      if (selectedPlan) params.append("planId", selectedPlan);
      if (lang) params.append("lang", lang);
      
      const API_URL = params.toString() ? `${baseURL}?${params}` : baseURL;
      
      const response = await axios.get(API_URL, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      
     
      
      return response.data;
    } catch (error) {
      console.error("Error fetching trx report details:", error);
      throw error;
    }
  };
  
  export default { trxReportDetails };